const STORAGE_KEY = 'genai-studio-intro-seen';

/**
 * Check if the user has already seen the intro video.
 * Uses localStorage for reliable persistence across browser sessions.
 */
export const getHasSeenIntroVideo = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

/**
 * Mark the intro video as seen so it won't play again.
 */
export const setHasSeenIntroVideo = (): void => {
  try {
    localStorage.setItem(STORAGE_KEY, 'true');
  } catch {
    // localStorage might be unavailable in some contexts
  }
};
